import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  const latest = articles.filter((a) => !a.featured).slice(0, 6);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-12">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              持续更新
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              最新内容
            </h2>
          </div>
          <Link
            to="/category/rumen"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latest.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex gap-4 p-4 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-lg overflow-hidden flex-shrink-0">
                <img
                  src={article.thumbUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-1.5 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2 mb-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span>·</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/rumen"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}